import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Button } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import HeroImage from './icons/hero.jpeg';
import TesterBudNavbar from '../subComponent/TesterBudNavBar';
import PracticeButton from '../subComponent/PracticeButton';
import PracticeDescription from '../subComponent/PracticeDescription';

const PracticeScenariosPage = () => {


  const buttonData = [
    { to: "/practice-ecommerece-website", label: "🛒 E-commerce Automation Practice" },
    { to: "/flight-booking-scenarios", label: "✈️ Flight Booking Automation Practice" },
    { to: "/practice-login-form", label: "🔐 Login Page for Automation" },
    { to: "/register", label: "📝 Registration Form Practice" },
    { to: "/practice-forms", label: "📋 Long Form Automation Practice" },
    { to: "/practice-different-ui-elements", label: "🎛️ UI Elements Practice & Automation" },
    { to: "/SeleniumXPathGuide", label: "🧭 Learn XPath for Selenium" },
    { to: "/forget-password", label: "🔑 Forget Password Page for Selenium" },
  ];

  return (
    <HelmetProvider>
      <Helmet>
        <title>Master UI Automation: Practice Scenarios for Selenium, Cypress & Playwright | TesterBud</title>
        <meta http-equiv="Content-type" content="text/html;charset=UTF-8" />
        <meta
          name="description"
          content="Hone your UI automation skills with TesterBud's free, interactive practice scenarios. Explore e-commerce, flight booking, forms, and more, optimized for Selenium, Cypress, and Playwright."
        />
        <meta
          name="keywords"
          content="UI automation practice, selenium practice scenarios, cypress testing examples, playwright automation exercises, test automation playground, web testing practice, free automation training, e-commerce testing practice, flight booking automation examples, login form automation practice, xpath learning selenium, testerbud"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="TesterBud Team" />
        <meta property="og:title" content="Master UI Automation: Practice Scenarios for Selenium, Cypress & Playwright | TesterBud" />
        <meta
          property="og:description"
          content="Hone your UI automation skills with TesterBud's free, interactive practice scenarios. Explore e-commerce, flight booking, forms, and more, optimized for Selenium, Cypress, and Playwright."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://testerbud.com/practice-scenarios" /> {/* Please update with the actual URL of this page */}
        <meta name="geo.region" content="GLOBAL" />
        <meta name="geo.placename" content="Global" />
      </Helmet>
      <div className="home-page">
        {/* Top Heading Container */}
        <Container fluid className="hero-section bg-primary text-white py-5" style={{ position: 'relative', overflow: 'hidden' }}>
          <Row className="align-items-center justify-content-center">
            <Col md={6} className="text-center text-md-start">

              <h3 className="display-4 fw-bold mb-3">TesterBud – The Ultimate Automation Playground</h3>
              <p className="lead mb-2">
                TesterBud – The Ultimate Playground for Automation Testers! 🚀 Practice XPath, UI automation, and real-world testing challenges with interactive dummy sites.
              </p>
              <Button
                as={Link}
                to="/practice-page-selection"
                variant="warning"
                size="md"
                className="fw-bold text-dark border-0 shadow-sm"
                style={{
                  padding: "24px 36px",
                  borderRadius: "20px",
                  transition: "all 0.3s ease-in-out"
                }}
              >
                Get Started ➜
              </Button>

            </Col>
            <Col md={5} className="d-none d-md-block text-center">
              {/* Replace with your actual hero image component or import */}
              <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: '60%', // Adjust the size of the circular area
                    height: '60%', // Ensure width and height are equal for a perfect circle
                    borderRadius: '70%', // This creates the circular shape
                    overflow: 'auto', // Clips the image to the circle
                    marginTop: '-4%',
                    marginRight: '10%',
                    marginBottom: '-4%',
                  }}
                >
                  <img src={HeroImage} alt="Automation Illustration" className="img-fluid" style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain', // Or 'cover' depending on desired behavior
                  }} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <TesterBudNavbar />

        {/* Buttons Container */}

        {/* Description Container */}
        <PracticeDescription />

        <Container className="py-5">
          <Row className="g-4 justify-content-center">
            {buttonData.map(({ to, label }, idx) => (
              <Col key={idx} md={6} lg={4}>
                <PracticeButton to={to} label={label} />
              </Col>
            ))}
          </Row>
        </Container>




        {/* Footer Container */}
        <Container fluid className="bg-light text-center py-3">
          <p className="text-muted">
            Ready to start automating? Explore, practice, and master!
          </p>
          <p className="mt-2">© {new Date().getFullYear()} TesterBud | Built for learners by learners 🚀</p>
        </Container>
      </div>
    </HelmetProvider>
  );
};

export default PracticeScenariosPage;

